import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
@Component({
    selector: 'app-ai-insight-tile',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ai-insight-tile.component.html',
    styleUrl: './ai-insight-tile.component.scss'
})
export class AiInsightTileComponent {
    getStatusClass(insightTitle: string): string {
        switch (insightTitle?.toLowerCase()) {
            case 'risk warning':
                return 'risk-container';

            case 'recommendation':
                return 'recommendation-container';

            case 'pattern detected':
                return 'pattern-container';

            case 'success metrics':
                return 'success-container';

            default:
                return 'gray-container';
        }
    }
    @Input() insightTitle!: string;
    @Input() insightInfo!: string;
    @Input() insightColor?: string; // Optional
}
